/* import __COLOCATED_TEMPLATE__ from './record-matching.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import templateOnlyComponent from '@ember/component/template-only';

interface Args {
  isSettingsPage?: boolean;
}

const RecordMatching = templateOnlyComponent<Args>();
export default RecordMatching;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Salesforce::ManageData::RecordMatching': typeof RecordMatching;
  }
}
